let nav = document.getElementById("navigation");
function toggleMenu() {
  nav.classList.toggle("navigation--visible");
}
